module.exports = __webpack_public_path__ + "static/media/slide1.038992c2.jpg";